if (!customElements.get('copy-link')) {
  class CopyLink extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.handleClick);
    }

    handleClick = () => {
      const url = window.location.href;

      /* Mobile: native share sheet when available */
      if (navigator.share) {
        navigator
          .share({ url })
          .catch(() => this.copyToClipboard(url));
      } else {
        this.copyToClipboard(url);
      }
    };

    copyToClipboard(url: string) {
      navigator.clipboard
        .writeText(url)
        .then(() => {
          this.classList.add('text-brand-disabled-text');
          setTimeout(() => this.classList.remove('text-brand-disabled-text'), 2000);
        });
    }
  }

  customElements.define('copy-link', CopyLink);
}
